import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { Ico } from "../../../components/icons/icons.jsx";

const ICON_MAP = {
  model: Ico.model,
  layers: Ico.layers,
  grid: Ico.grid,
  device: Ico.device,
};

export function AssetModalField({
  label,
  value,
  onChange,
  placeholder,
  error,
  icon = "model",
  type = "text",
  as = "input",
  options = [],
  disabled = false,
}) {
  const { c, dark, accentHex: A } = useThemeSlice();
  const fieldIcon = ICON_MAP[icon] ?? Ico.model;

  return (
    <label style={{ display: "block", marginBottom: 16 }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
        <div
          style={{
            width: 34,
            height: 34,
            borderRadius: 8,
            background: dark ? `${A}18` : `${A}10`,
            border: `1px solid ${dark ? `${A}35` : `${A}25`}`,
            color: A,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            marginTop: 22,
          }}
        >
          {fieldIcon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <span style={{ display: "block", fontSize: 13, fontWeight: 700, color: c.text, marginBottom: 8 }}>{label}</span>
          {as === "select" ? (
            <select
              value={value}
              disabled={disabled}
              onChange={(e) => onChange(e.target.value)}
              style={fieldStyle(c, dark, error, disabled)}
            >
              <option value="">{placeholder}</option>
              {options.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          ) : (
            <input
              type={type}
              value={value}
              disabled={disabled}
              onChange={(e) => onChange(e.target.value)}
              placeholder={placeholder}
              style={fieldStyle(c, dark, error, disabled)}
            />
          )}
          {error ? <span style={{ display: "block", marginTop: 4, fontSize: 11, color: "#EF4444", fontWeight: 600 }}>{error}</span> : null}
        </div>
      </div>
    </label>
  );
}

function fieldStyle(c, dark, error, disabled) {
  return {
    width: "100%",
    height: 42,
    padding: "0 12px",
    borderRadius: 8,
    border: `1px solid ${error ? "#EF4444" : c.cardBdr}`,
    background: disabled ? c.hover : dark ? "rgba(255,255,255,0.04)" : c.card,
    color: c.text,
    fontSize: 13,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    opacity: disabled ? 0.75 : 1,
    cursor: disabled ? "not-allowed" : "text",
  };
}
